<template>
  <div>
    <h2 is="sui-header">新增關鍵字推送</h2>
    <sui-form>
      <sui-form-field>
        <label>關鍵字</label>
        <input placeholder="可以填入多個，用英文逗點隔開" v-model="keywords"/>
      </sui-form-field>
      <sui-form-fields fields="three">
        <sui-form-field>
          <label>地區</label>
          <sui-dropdown
            :options="regions"
            placeholder="地區"
            search
            selection
            v-model="regionCode"
          />
        </sui-form-field>
        <sui-form-field>
          <label>開始時間</label>
          <datetime type="datetime" v-model="startDate"></datetime>
        </sui-form-field>
        <sui-form-field>
          <label>結束時間</label>
          <datetime type="datetime" v-model="endDate"></datetime>
        </sui-form-field>
      </sui-form-fields>
      <AdminHint v-if="!isAdmin"/>
      <sui-button :loading="loading" type="submit" :disabled="!canBePreviewed" @click="preview">預覽</sui-button>
      <sui-button :loading="creating" primary type="submit" :disabled="!canBeSubmitted || creating" @click="createEvent">新增</sui-button>
    </sui-form>
    <sui-message v-if="err" negative>
      <sui-message-header>發生錯誤</sui-message-header>
      {{err}}
    </sui-message>
    <sui-segment v-if="videos && videos.length > 0">
      <sui-card-group :items-per-row="3">
        <sui-card v-for="video in videos" :key="video.id">
          <sui-image :src="video.thumbnail" />
          <sui-card-content>
            <sui-card-meta>{{formatDateTime(video.created)}}
              <sui-icon class="right floated" :link="true" name="external alternate" @click="openUrl(video.url)"></sui-icon>
            </sui-card-meta>
            <sui-card-description>{{video.title}}</sui-card-description>            
          </sui-card-content>
        </sui-card>
      </sui-card-group>
    </sui-segment>
  </div>
</template>

<script>
import regionData from 'country-region-data';
import { searchYouTubeVideos } from '../../../functions/youtube-utils';
import firebase from 'firebase/app';
import 'firebase/firestore';
import { mapState } from 'vuex';
import AdminHint from '@/components/AdminHint.vue';

export default {
  data () {
    return {
      regionCode: undefined,
      keywords: undefined,
      startDate: undefined,
      endDate: undefined,
      videos: undefined,
      loading: false,
      creating: false,
      err: undefined,
    };
  },
  computed: {
    regions () {
      return regionData.map(r => {
        return {
          key: r.countryShortCode,
          value: r.countryShortCode,
          flag: r.countryShortCode.toLowerCase(),
          text: r.countryName,
        };
      })
    },   
    canBeSubmitted () {
      const { regionCode, keywords, startDate, endDate } = this;
      return regionCode && keywords && startDate && endDate && true;
    },
    canBePreviewed () {
      const { keywords } = this;
      return keywords && true;
    },
    formattedKeywords () {
      const { keywords } = this;
      return keywords.split(',').map(k => k.trim()).map(k => k.toLowerCase());
    },
    ...mapState([
      'userId',
      'isAdmin',
    ]),
  },
  methods: {
    async createEvent () {
      try {
        const { formattedKeywords: keywords, regionCode, startDate, endDate, userId } = this;
        this.creating = true;
        const videos = await searchYouTubeVideos({
          googleApiKey: process.env.VUE_APP_GOOGLE_API_KEY,
          maxResults: 30,
          keywords,
          regionCode,
        });
        const db = firebase.firestore();
        await db.collection('event_splashes').add({
          keywords,
          startDate: new Date(startDate),
          endDate: new Date(endDate),
          regionCode,
          videos,
          creator: userId,
          manual: true,
        });
        this.$router.replace({ name: 'Home' });
      } catch (err) {
        this.err = err;
      }
      this.creating = false;
    },
    formatDateTime (date) {
      return (new Date(date)).toLocaleString();
    },
    async preview () {
      this.loading = true;
      const { formattedKeywords, regionCode } = this;
      this.videos = await searchYouTubeVideos({
        googleApiKey: process.env.VUE_APP_GOOGLE_API_KEY,
        maxResults: 30,
        keywords: formattedKeywords,
        regionCode,
      });
      this.loading = false;
    },
    openUrl (url) {
      window.open(url, '_blank');
    },
  },
  components: {
    AdminHint,
  },
}
</script>
